var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('role-selector-pills',{attrs:{"activeRoles":_vm.activeRoles,"config":_vm.rolesConfig},on:{"role-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }